import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();

// The install prompt has to be caught HERE, not in the component that offers it: Chrome
// fires `beforeinstallprompt` once, early, usually before React has mounted, and the event
// is gone if nobody takes it. Stashing it on window lets the Profile's Install button
// replay it whenever the person gets there. (user 2026-10-06)
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();                       // keep Chrome's own mini-infobar out of the way
  window.__nexwaveInstallPrompt = e;
  window.dispatchEvent(new Event('nexwave:installable'));
});
window.addEventListener('appinstalled', () => { window.__nexwaveInstallPrompt = null; });

// Register service worker for PWA install. Force an update check on every load
// and reload the page once a new SW takes control, so cached versions of sw.js
// don't get stuck running old logic.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      reg.update().catch(() => {});
    }).catch(() => {});

    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
